import { getDashboardStats } from '@/services/academy/dashboard.service'

export default {
	namespaced: true,

	state: {
		dashboardData: null,
		dashboardStatus: 'init',
	},

	mutations: {
		SET_DASHBOARD_DATA(state, data) {
			state.dashboardData = data
		},
		SET_DASHBOARD_STATUS(state, status) {
			state.dashboardStatus = status
		},
	},

	actions: {
		async fetchDashboard({ commit }) {
			commit('SET_DASHBOARD_STATUS', 'pending')
			try {
				const { data } = await getDashboardStats()
				commit('SET_DASHBOARD_DATA', data)
			} catch (error) {
				console.error('Dashboard fetch error:', error)
			} finally {
				commit('SET_DASHBOARD_STATUS', 'init')
			}
		},
	},

	getters: {
		getDashboardStatus: s => s.dashboardStatus,
		getDashboardData: s => s.dashboardData,
		getTotals: s => s.dashboardData?.totals ?? null,
		getLatestCourses: s => s.dashboardData?.latest_courses ?? [],
		getLatestCreators: s => s.dashboardData?.latest_creators ?? [],
		getCoursesByStatus: s => s.dashboardData?.courses_by_status ?? {},
		getRevenueMonthly: s => s.dashboardData?.revenue_monthly ?? [],
		getBookingsByDay: s => s.dashboardData?.bookings_by_day ?? [],
		getPendingModeration: s => s.dashboardData?.pending_moderation ?? [],
	},
}
